import * as React from 'react';
import injectSheet, { Styles, WithSheet } from 'react-jss';

const styles: Styles<'root'> = {
    root: {
        display: 'block',
        position: 'absolute',
        inset: 0,
    }
};

class PageContentClass extends React.PureComponent<WithSheet<'root', React.PropsWithChildren<{}>>> {
    public render(): React.ReactNode {
        return (
            <div className={this.props.classes.root}>
                {this.props.children}
            </div>
        );
    }
}

export default injectSheet(styles)(PageContentClass);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/mainContainer/PageContent.tsx